import useFetch from '../../../hooks/useFetch';
import rideApi from '../rideApi';

export default function useAnnulerRideApi() {
    return useFetch(rideApi.annuler);
}
